<div class="preview-container p-16">
    <div class="preview-custom">
        <span class="cm-icon">{{ ('Ticket_Template_List.Empty_Preset' | trans) | async}}</span>
    </div>
</div>
